import styled from "styled-components"
import { Button } from "buoy-core"
import { colors } from "buoy-theme"

const NpsRatingButton = styled(Button).attrs({
  buttonStyle: "feedback",
  backgroundColor: "white",
  textColor: "primary",
  borderColor: "neutral",
  hoverBackgroundColor: "transparent",
  hoverBorderColor: "primary",
})`
  position: relative;
  flex-basis: 100%;
  border-radius: 0px;
  padding: 6px;

  margin-right: auto;

  &:first-child {
    margin-top: 0;
    margin-right: 0;
  }

  &:last-child {
    margin-bottom: 0;
    margin-left: 0;
  }

  :focus {
    background-color: ${colors.primary};
    color: white;
  }

  @media (min-width: 640px) {
    border-radius: 4px;
    margin: 0 4px;
    height: 36px;
    width: 36px;
    padding: 0;
    flex-basis: auto;
  }
`

export { NpsRatingButton as default }



// WEBPACK FOOTER //
// ./assets/feedback/components/nps/NpsRatingButton.js